import axios from "axios";

export default {
  namespaced: true,
  state: {
    paystatements: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    paystatementsMessage: ''
  },
  mutations: {
    RECEIVED_PAYSTATEMENTS(state, payload) {
      state.paystatements = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_PAYSTATEMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_PAYSTATEMENT(state, payload) {
      state = Object.assign(state, {
        paystatements: [...state.paystatements, payload],
        isReceiving: false,
      })
    },
    RECEIVING_PAYSTATEMENT(state) {
      state.isReceiving = true;
    },
    UPDATED_PAYSTATEMENT(state, payload) {
      console.log(state.paystatements);
      console.log(payload);
      let index = state.paystatements.findIndex(paystatement => paystatement._id === payload._id);
      state = Object.assign(state, {
        paystatements: state.paystatements.map((paystatement, i) => {
          if (i === index) {
            return Object.assign({}, paystatement, payload);
          }
          return paystatement;
        }),
        isUpdating: false,
        paystatementsMessage: 'PayStatements has been updating!',
      })
    },
    UPDATING_PAYSTATEMENT(state) {
      state.isUpdating = true;
    },
    DELETED_PAYSTATEMENT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.paystatements.findIndex(paystatement => paystatement._id === payload._id);
      console.log(indexToDelete);
      let paystatements = [...state.paystatements];
      paystatements.splice(indexToDelete, 1);
      state = Object.assign(state, {
        paystatements: [...paystatements],
        isDeleting: false,
        idToDelete: null,
        paystatementsMessage: 'PayStatement has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_PAYSTATEMENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    insertPayStatementRequest({dispatch}, payload) {
      dispatch("receivingPayStatements");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      url = 'https://api.accountxc.com:3100/insert/paystatement';
      data = payload;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      return axios(post)
      .then(response=> {
        let paystatement = response.data.paystatement;
        paystatement.transaction = response.data.transaction;
        dispatch("receivePayStatement", paystatement);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deletePayStatementRequest({dispatch}, payload) {
      dispatch("deletingPayStatement", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/paystatement/' + payload._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      let del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(response=>{
        dispatch("deletePayStatement", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async getPayStatementsRequest({dispatch}) {
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/paystatements';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers,})
      .then(res => {
        dispatch("receivePayStatements", res.data);
      })
    },
    async getPayStatementsByPayroll({dispatch}, payrollid) {
      dispatch("receivingPayStatements");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/paystatements/bypayroll/' + payrollid;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get", url: url, headers: headers,});
      dispatch("stopReceiving");
      return response.data;
    },
    async getPayStatementWithKey({dispatch},  keyid) {
      dispatch("receivingPayStatements");
      console.log("HERE", keyid);
      var url = 'https://api.accountxc.com:3100/get/paystatement/withkey/' + keyid;
      console.log("HERE", url);
      var header = {'Content-Type': 'application/json'};
      const response = await axios({method: "get", url: url, headers: header});
      return response.data;
    },
    updatePayStatementRequest({dispatch}, payload) {
      dispatch("updatingPayStatement");
      console.log("******************************************************");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/paystatement/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then((response)=> {
        console.log("******************************************************");
        console.log(response.data);
        dispatch("updatePayStatement", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updatePayStatementImageRequest({dispatch}, payload) {
      dispatch("updatingPayStatement");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.accountxc.com:3100/update/paystatement/image/' + id;
      data = new FormData();
      data.append('image', payload.paystatementimage, payload.imagename); 
      delete payload['paystatementimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        dispatch("updatePayStatement", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    receivePayStatements({commit}, payload) {
      commit("RECEIVED_PAYSTATEMENTS", payload)
    },
    receivingPayStatements({commit}) {
      commit("RECEIVING_PAYSTATEMENTS")
    },
    receivePayStatement({commit}, payload) {
      commit("RECEIVED_PAYSTATEMENT", payload)
    },
    stopReceiving({commit}) {
      commit("STOP_RECEIVING")
    },
    receivingPayStatement({commit}) {
      commit("RECEIVING_PAYSTATEMENT")
    },
    updatePayStatement({commit}, payload) {
      commit("UPDATED_PAYSTATEMENT", payload)
    },
    updatingPayStatement({commit}) {
      commit("UPDATING_PAYSTATEMENT")
    },
    deletePayStatement({commit}, payload) {
      commit("DELETED_PAYSTATEMENT", payload)
    },
    deletingPayStatement({commit}, payload) {
      commit("DELETING_PAYSTATEMENT", payload)
    }
  },
};
